// extracted by mini-css-extract-plugin
export var attachment = "_ma-a";
export var emailContainer = "_ma-4";
export var emailContentPaddedContainer = "_ma-b";
export var emailHeader = "_ma-6";
export var emailIframe = "_ma-3";
export var emailInfoIcon = "_ma-9";
export var emailShortenedSummary = "_ma-e";
export var infoDropdown = "_ma-0";
export var infoRowBoundedContent = "_ma-d";
export var internal = "_ma-5";
export var merchant = "_ma-8";
export var messageInputContainer = "_ma-h";
export var normal = "_ma-7";
export var replyCard = "_ma-f";
export var subtleButton = "_ma-1";
export var subtleButtonIconContainer = "_ma-2";
export var toggleViewRepliesButton = "_ma-c";
export var wrappingText = "_ma-g";